const PhoneLoginSentNotification = ({ userPhoneNumber, handleChangePhone }) => (
  <div className="swpm-login-phone swpm-modal-screen">
    <div className="swpm-login-phone__container swpm-login-phone__container--sent">
      <div className="swpm-login-phone__info">
        <h1>Complete login on your phone</h1>
        <p>
          We just send a text to <strong>{userPhoneNumber}</strong>. <br /> Open the link
          in the text to log in.
        </p>
      </div>
      <div className="swpm-login-phone__phone"></div>
      <div className="swpmdl__bottom-controls">
        <button
          className="swpmdl-secondary-buttonlink"
          id="swpmdl-login-qr-button"
          onClick={handleChangePhone}
        >
          Change phone number
        </button>
      </div>
    </div>
  </div>
)

export default PhoneLoginSentNotification
